module.exports = "<h1 class=\"alpha\">\n    {{ titleTxt }}\n</h1>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-title/dist/template.html
// module id = ../node_modules/xo-title/dist/template.html
// module chunks = 0